import { render } from "./KubernetesAccessTab.vue?vue&type=template&id=224b9aa8&scoped=true"
import script from "./KubernetesAccessTab.vue?vue&type=script&lang=js"
export * from "./KubernetesAccessTab.vue?vue&type=script&lang=js"

import "./KubernetesAccessTab.vue?vue&type=style&index=0&id=224b9aa8&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224b9aa8"]])

export default __exports__